import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const purchaseOrderColumns: GridColumnConfig[] = [
  {
    title: 'Purchase Order No',
    field: 'purchaseOrderNo',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'File Name',
    field: 'fileName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'File Type',
    field: 'fileType',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded By',
    field: 'purchaseOrderUploadedBy',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded On',
    field: 'purchaseOrderUploadedOn',
    filter: 'text',
  },
];
